import type { SVGProps } from 'react';

interface SignalIconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const SignalIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & SignalIconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 16 16"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <g clipPath="url(#signal_svg__a)">
      <path
        d="M2.889 0A2.89 2.89 0 0 0 0 2.889V13.11A2.89 2.89 0 0 0 2.889 16H13.11A2.89 2.89 0 0 0 16 13.111V2.89A2.89 2.89 0 0 0 13.111 0zm.444 4c-.36 0-.666-.282-.666-.642V3.31c0-.35.27-.642.62-.643h.046c5.523 0 10 4.477 10 10v.046a.63.63 0 0 1-.643.62h-.048c-.36 0-.642-.306-.642-.666A8.667 8.667 0 0 0 3.333 4m5.817 9.333h-.08c-.354 0-.626-.312-.626-.666a5.11 5.11 0 0 0-5.11-5.111c-.355 0-.667-.272-.667-.626v-.08c0-.337.255-.624.592-.627h.074a6.444 6.444 0 0 1 6.444 6.518c-.003.337-.29.592-.627.592m-5.15 0a1.333 1.333 0 1 1 0-2.666 1.333 1.333 0 0 1 0 2.666"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="signal_svg__a">
        <path d="M0 0h16v16H0z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
